import { State } from "../state";
import { AssetState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { Asset } from "@/interfaces/assets";

export const getters = {
  assets: (state: AssetState): Asset[] => state.assets,
};

const { read } = getStoreAccessors<AssetState, State>("");

export const readAssets = read(getters.assets);
